import { useState, useEffect } from "react"

import { fetchData } from "./utils"
import Loader from "./components/Loader"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAward, faBroom, faCircleCheck, faClock, faDropletSlash, faGem, faHandLizard, faLandmark } from '@fortawesome/free-solid-svg-icons';
import Slider from "./components/Slider";
import { faUser, faTrophy, faGear, faMedal } from "@fortawesome/free-solid-svg-icons";
import ContactBar from "./components/ContactBar";



const HomePage = () => {
    const [content, setContent] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        fetchData('pageContent/home', 'GET', null, (data) => {
            setContent(data);
            setLoading(false)
        });
  }, []);

    if (loading) return <Loader/>
    return (
        <div>
          <div className="personal-white home-container-1-part">
            <div className="home-part-1-left">
              <div>
                <h2 className="font-weight-400 multicolor-text">LUX SUFITY</h2>
                <h1 className="tytulGlowny">{content.heroTitle}</h1>
                <div className="gold-border">
                  <h4 className="tytul-pracy">{content.heroSubtitle}</h4>
                  <span className="abouteLS">{content.aboutLuxSufity}</span>
                </div>
              </div>
            </div>
            <div className="home-part-1-right">
              <img className="w-100p part-1-Right" loading="eager" src="/img_0481.JPG" alt="" />
            </div>
          </div>

          <div className="home-container-2-part">
            <div className="home-part-2-left">
              <div>
                <h1>O firmie</h1>
                <div className="abouteLuxS">
                  <h3 className="f-w-500">{content.greetings}</h3>
                  <span className="w-100p-for-mobile">{content.advantagesTitle}</span>
                </div>
                <div className="przewagi">
                  <h3 className="f-w-500">{content.advantagesAbout}</h3>
                  <ul>
                    <li>{content.przewaga1}</li>
                    <li>{content.przewaga2}</li>
                    <li>{content.przewaga3}</li>
                    <li>{content.przewaga4}</li>
                    <li>{content.przewaga5}</li>
                    <li>{content.przewaga6}</li>
                    <li>{content.przewaga7}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="home-part-2-right">
              <img className="w-100p" src="/Airbrush-Image-Enhancer-1751377140847.jpg" alt="" />
            </div>
        </div>
        <div>
          <section className="stats lux-stats">
            <h2 className="lux-stats-title">Osiągnięcia Lux Sufity</h2>

            <div className="cards">
              <div className="card">
                <div className="icon">
                  <FontAwesomeIcon icon={faGem} />
                </div>
                <h3>{content.osiagniecia1Tytul}</h3>
                <p>{content.osiagniecia1}</p>
              </div>

              <div className="card">
                <div className="icon">
                  <FontAwesomeIcon icon={faAward} />
                </div>
                <h3>{content.osiagniecia2Tytul}</h3>
                <p>{content.osiagniecia2}</p>
              </div>
              <div className="card">
                <div className="icon">
                  <FontAwesomeIcon icon={faCircleCheck} />
                </div>
                <h3>{content.osiagniecia3Tytul}</h3>
                <p>{content.osiagniecia3}</p>
              </div>

              <div className="card">
                <div className="icon">
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <h3>{content.osiagniecia4Tytul}</h3>
                <p>{content.osiagniecia4}</p>
              </div>
            </div>
          </section>
        </div>
      <div>
        <span className="types-of-ceilings-title">rodzaje sufitów</span>
        <div className="types-of-ceilings">
          <div>
            <div><img src="/lustrzane_type.jpg" alt="" /></div>
            <div className="titleOfTypes">{content.lustrzaneTypeTitle}</div>
            <div>{content.lustrzaneType}</div>
          </div>
          <div>
            <div><img src="/matowe_type.jpg" alt="" /></div>
            <div className="titleOfTypes">{content.matoweTypeTitle}</div>
            <div>{content.matoweType}</div>
          </div>
          <div>
            <div><img src="/satyna_type.jpg" alt="" /></div>
            <div className="titleOfTypes">{content.satynoweTypeTitle}</div>
            <div>{content.satynoweType}</div>
          </div>
          <div>
            <div><img src="/led_os.jpg" alt="" /></div>
            <div className="titleOfTypes">{content.ledTypeTitle}</div>
            <div>{content.ledType}</div>
          </div>
          <div>
            <div><img src="/nadrukType (2).jpg" alt="" /></div>
            <div className="titleOfTypes">{content.nadrukTypeTitle}</div>
            <div>{content.nadrukType}</div>
          </div>
        </div>
      </div>
      <div className="block-przewagi-sufitow">
                <span>
                    Przewagi sufitów napinanych
                </span>
                <div>
                    <div>
                        <FontAwesomeIcon className="icon-przewaga" icon={faDropletSlash} />
                        <span>
                            {content.przewaga1Tytul}
                        </span>
                        <p className="f-size-for-site">
                            {content.przewaga1}
                        </p>
                    </div>
                    <div>
                        <FontAwesomeIcon className="icon-przewaga" icon={faClock} />
                        <span>
                            {content.przewaga2Tytul}
                        </span>
                        <p className="f-size-for-site">
                            {content.przewaga2}
                        </p>
                    </div>
                    <div>
                        <FontAwesomeIcon className="icon-przewaga" icon={faLandmark} />
                        <span>
                            {content.przewaga3Tytul}
                        </span>
                        <p className="f-size-for-site">
                            {content.przewaga3}
                        </p>
                    </div>
                    <div>
                        <FontAwesomeIcon className="icon-przewaga" icon={faBroom} />
                        <span>
                            {content.przewaga4Tytul}
                        </span>
                        <p className="f-size-for-site">
                            {content.przewaga4}
                        </p>
                    </div>
                    <div>
                        <FontAwesomeIcon className="icon-przewaga" icon={faHandLizard} />
                        <span>
                            {content.przewaga5Tytul}
                        </span>
                        <p className="f-size-for-site">
                            {content.przewaga5}
                        </p>
                    </div>
                </div>
            </div>
            <div>
              <Slider/>
            </div>
    </div>
        
    )
}

export default HomePage